import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { UserRole } from 'service/apicataleg/types/ApiCatalegTypes';

type UserCredentials = {
  accessToken: string;
  username: string;
  name: string;
  empre: number;
  role: UserRole;
  codi: number;
  refreshToken: string;
};

export type AuthenticationSliceState = {
  user: UserCredentials | null;
  isFetching: boolean;
  isAuthenticated: boolean;
};

type TokensPayload = {
  accessToken: string;
  refreshToken: string;
};

const storageUser = localStorage.getItem('user');
const userPayload = storageUser ? JSON.parse(storageUser) : null;

const initialState: AuthenticationSliceState = {
  user: userPayload,
  isFetching: false,
  isAuthenticated: !!storageUser,
};

export const AuthenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    LoginRequestStart: (state, action: PayloadAction<any>) => {
      state.isFetching = true;
      state.isAuthenticated = false;
    },
    LoginSuccess: (state, action: PayloadAction<UserCredentials>) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      localStorage.setItem('user', JSON.stringify(action.payload));
    },
    LoginFailure: (state, action: PayloadAction<string>) => {
      state.isFetching = false;
      state.isAuthenticated = false;
    },
    UpdateTokens: (state, action: PayloadAction<TokensPayload>) => {
      const { payload } = action;
      const { accessToken, refreshToken } = payload;
      if (state.user) {
        state.user.accessToken = accessToken;
        state.user.refreshToken = refreshToken;
      }
      localStorage.setItem('user', JSON.stringify(state.user));
    },

    LogoutRequest: (state, action: PayloadAction<any>) => {
      localStorage.removeItem('user');
      return {
        user: null,
        isAuthenticated: false,
        isFetching: false,
      };
    },
  },
});

export const { LoginRequestStart, LoginSuccess, LoginFailure, LogoutRequest, UpdateTokens } =
  AuthenticationSlice.actions;

export default AuthenticationSlice.reducer;
